<template>
<div>
    <!-- tab标签选择区域 -->
    <div class="tabs_box" >
        <el-tabs v-model="editableTabsValue" type="card" class ="myTab">
           <el-tab-pane  v-for="(item, index) in editableTabs" :key="index"  :label="item.title" :name="item.name">
              <el-form ref="queryFormRef" :inline="true" :model="queryForm">
                <!-- 未获批申请 -->
                 <el-row v-if ="editableTabsValue==='1'">
                    <el-col :span="12">
                      <el-form-item label="搜索" prop="keyWord" label-width="105px">
                        <el-input v-model="queryForm.keyWord" clearable placeholder="请输入关键字"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-button  plain size="mini" class="btn btn2"  @click="search">搜索</el-button>
                    </el-col>
                  </el-row>

                <!-- 审核中 -->
                <el-row v-if ="editableTabsValue==='2'">
                    <el-col :span="10">
                      <el-form-item label="申请阶段" prop="type" label-width="105px">
                        <el-select clearable v-model="queryForm.type" placeholder="全部" style="width: 12rem;">
                            <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                     <el-col :span="10">
                      <el-form-item label="搜索" prop="keyWord" label-width="105px">
                        <el-input clearable v-model="queryForm.keyWord" placeholder="请输入关键字"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="4">
                        <el-button  plain size="mini" class="btn btn2"  @click="search">搜索</el-button>
                    </el-col>
                </el-row>

                <!-- 已获批申请  -->
                <el-row v-if ="editableTabsValue==='3'">
                <el-col :span="12">
                      <el-form-item label="搜索" prop="keyWord" label-width="105px">
                        <el-input clearable v-model="queryForm.keyWord" placeholder="请输入关键字"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-button  plain size="mini" class="btn btn2"  @click="search">搜索</el-button>
                    </el-col>
                </el-row>
              </el-form>
           </el-tab-pane>

          <div class="btnBox1">

            <el-dropdown trigger="click">
          <span class="el-dropdown-link">
           <el-button size="mini"  plain >筛选列</el-button>
          </span>
              <el-dropdown-menu slot="dropdown" class="dropdownbox1">
                <el-checkbox-group style="display: flex;flex-direction: column" v-model="checkedDatas" @change="checkChange">
                  <el-checkbox v-for="item in fieldData1" :label="item" :key="item.field">{{item.label}}</el-checkbox>
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="mini" type="warning" @click="getExcel(editableTabsValue)">导出数据到Excel</el-button>

            <el-button size="mini"  style="margin-left: 0" plain @click="printDiv">打印</el-button>
          </div>
        </el-tabs>




    </div>


    <!-- 查询结果列表 -->
  <div  ref="printContent">

    <Table
      ref="hostsTable"
      :fieldData="fieldData"
      :tableData="tableData"
      :page="true"
      @pageChange="pageChange"
      @sizeChange="sizeChange"
      :total="total"
      :pageIndex="currentPage"
      type="index"
      :tableSort="tableSort"
      :cellStyles="cellStyles"
      :headerStyles="headerStyles"
      style="width: 100%; margin-top: 20px;"
    >
      <el-table-column
        prop:id
        slot="opts"
        label="操作"
        min-width="150px"
      >
        <template slot-scope="scope" >
          <el-button type="text" size="small" @click="toDetails(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </Table>

  </div>








</div>

</template>

<script>
import Table from "../../../comm/components/Table/index.vue";
import {exportApplyInReview, exportApplyNoPass, exportApplyPass, getApplicationInfo} from "../../api/home"
import {mapMutations} from "vuex";
import html2canvas from "html2canvas";
import print from 'print-js'
import {analysisexport} from "../../../landmark-admin/api/nationStatistics";
import {downloadFiles} from "../../../comm/utils/download";
export default {
    components:{Table},
    data(){
        return{
          checkedDatas:[],
          fieldData1:{},
            //表格样式
            headerStyles:
            {
                color:'rgb(255, 255, 255)',
                padding: '0.375rem',
                'border-right': '2px solid #ffffff',
                'text-align': 'center',
                background: 'rgb(27, 61, 109)'
            },
            cellStyles: {'text-align': 'center'},
            // 列表定义
            size: "medium", // 列表大小
            total: 0,       // 总记录数
            currentPage: 1, // 初始页
            pageSize: 10,   // 每页的数据条数 需要与table组件里的一致
            tableSort: { prop: "id", order: "descending" }, // 默认排序规则
            //表格数据
            tableData: [],

            fieldData:[
                {
                field: "applicationNumber",
                label: "申请编号",
                width: "",
                sortable:false
                },
                {
                field: "name",
                label: "产品名称",
                width: "",
                sortable:false
                },
                {
                field: "applyName",
                label: "申请机构",
                width: "",
                sortable:false
                },
                {
                field: "applyPhone",
                label: "申请机构电话",
                width: "",
                sortable: false
                },
                {
                field: "applyTime",
                label: "申请时间",
                width: "",
                sortable:false
                },
                {
                field: "entryTime",
                label: "未获批时间",
                width: "140",
                sortable:false
                }
            ],
            editableTabsValue:'1',
            editableTabs:[
                {title:'未获批申请',name:'1'},
                {title:'审核中',name:'2'},
                {title:'已获批申请',name:'3'}
            ],

            queryForm:{
                keyWord:'',
                type:''
            },
            typeList:[
                {
                    value:'Trial',
                    label:'初审阶段'
                },
                {
                    value:'FormalExamination',
                    label:'形式审查阶段'
                },
                {
                    value:'Evaluation',
                    label:'技术审查阶段'
                },
                {
                    value:'Accept',
                    label:'初步认定公告阶段'
                },
                {
                    value:'Objection',
                    label:'异议期阶段'
                },

                {
                    value:'Approval',
                    label:'认定公告阶段'
                }

            ],//"Trial","初审阶段" "FormalExamination","形式审查阶段" "Evaluation","技术审查阶段" "Objection","异议期阶段" "Accept","初步认定公告阶段" "Approval","认定公告阶段"
        }
    },
    watch:{
    editableTabsValue(val){
      this.queryForm={}
      if(this.editableTabsValue=='1'){
        this.changeQuery(val)
        this.currentPage=1
        this.submitForm()
      }else if(this.editableTabsValue=='2'){
        this.changeQuery(val)
        this.currentPage=1
        this.submitForm()
        }else if(this.editableTabsValue=='3'){
        this.changeQuery(val)
        this.currentPage=1
        this.submitForm()
        }
       this.tableData=null
       this.total = 0
    }

    },

  created() {
    this.editableTabsValue = localStorage.getItem('activeTab')   || '1'
  },
  mounted(){
      this.submitForm()
      this.checkedDatas =  this.fieldData
      this.fieldData1 = this.fieldData
    },
    methods:{
      search(){
        this.currentPage =1
        this.submitForm()

      },
        submitForm(){
            let params ={}

            if(this.editableTabsValue ==1){
                 //未获审批申请
                params ={
                type : 'No_Pass',
                keyWord : this.queryForm.keyWord,
                page : this.currentPage,
                limit : this.pageSize
                }
            }else if(this.editableTabsValue ==2){
                //申请中
                params ={
                type : this.queryForm.type,
                keyWord : this.queryForm.keyWord,
                page : this.currentPage,
                limit : this.pageSize
                }

            }else if(this.editableTabsValue ==3){
                //已获审批申请
                params ={
                type : 'Pass',
                keyWord : this.queryForm.keyWord,
                page : this.currentPage,
                limit : this.pageSize
                }

            }
            getApplicationInfo(params).then(res=>{
                if(res.errorCode==200){
                    this.tableData = res.data.data
                    this.total = res.data.count
                }
            })
        },
        changeQuery(val){
            if(val =='1'){
                this.fieldData = [
                {
                field: "applicationNumber",
                label: "申请编号",
                width: "",
                sortable:false
                },
                {
                field: "name",
                label: "产品名称",
                width: "",
                sortable:false
                },
                {
                field: "applyName",
                label: "申请机构",
                width: "",
                sortable:false
                },
                {
                field: "applyPhone",
                label: "申请机构电话",
                width: "",
                sortable: false
                },
                {
                field: "applyTime",
                label: "申请时间",
                width: "",
                sortable:false
                },
                {
                field: "entryTime",
                label: "未获批时间",
                width: "140",
                sortable:false
                }
            ]
            }
            else if(val == '2'){
                //审核中列表字段
                this.fieldData =[
                {
                field: "applicationNumber",
                label: "申请编号",
                width: "",
                sortable:false
                },
                {
                field: "name",
                label: "产品名称",
                width: "",
                sortable:false
                },
                {
                field: "applyName",
                label: "申请机构",
                width: "",
                sortable:false
                },
                {
                field: "applyTime",
                label: "申请时间",
                width: "",
                sortable:false
                },
                {
                field: "stateName",
                label: "所在阶段",
                width: "",
                sortable:false
                }

                ]


            }
            else if(val=='3'){
                //已获审批
                 this.fieldData =[
                    {
                field: "applicationNumber",
                label: "申请编号",
                width: "",
                sortable:false
                },
                {
                field: "name",
                label: "产品名称",
                width: "",
                sortable:false
                },
                {
                field: "applyName",
                label: "申请机构",
                width: "",
                sortable:false
                },

                {
                field: "applyTime",
                label: "申请时间",
                width: "",
                sortable:false
                },
                {
                field: "entryTime",
                label: "获批时间",
                width: "",
                sortable:false
                }
            ]
            }


          this.checkedDatas =  this.fieldData
          this.fieldData1 = this.fieldData
        },

      //筛选列
      checkChange(val){
        this.fieldData = val
      },

      //导出excel
      getExcel(editableTabsValue) {

        let params = {
          type:editableTabsValue == '1' ? 'No_Pass' :(editableTabsValue == '2' ? null :'Pass'),
          page : this.currentPage,
          limit : this.pageSize,
          keyWord:this.queryForm.keyWord,  //正序/倒序
        }
          if (editableTabsValue == '1'){ //未获审批申请

            exportApplyNoPass(params).then(res=>{
              downloadFiles(res, '未获审批申请'+'.xls')
            })
          }

        if (editableTabsValue == '2'){ //审核中
          exportApplyInReview(params).then(res=>{
            downloadFiles(res, '审核中'+'.xls')
          })
        }

        if (editableTabsValue == '3'){  //已获审批申请


          exportApplyPass(params).then(res=>{
            downloadFiles(res, '已获审批申请'+'.xls')
          })
        }






      },

      //打印网页
      printDiv() { // 转图片打印
        html2canvas(this.$refs.printContent,{
          allowTaint: false,
          useCORS: true,
          height: this.$refs.printContent.outerHeight,
          width: this.$refs.printContent.outerWidth,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight,

        }).then((canvas) => {
          // let url = canvas.toDataURL('image/jpeg', 1.0)
          const url = canvas.toDataURL()
          this.img = url
          printJS({
            printable: url,
            type: 'image',
            documentTitle: '打印图片'
          })

        })
      },
            // 分页
            pageChange(pageIndex) {
            //console.log("触发分页事件");
            this.currentPage = pageIndex;
            this.submitForm();
            },
            sizeChange(size) {
            //console.log("触发改变每页条数的事件");
            //console.log(size);
            this.pageSize = size;
            this.submitForm();
            },

            ...mapMutations(['activeNameChange']),

             //详情
          toDetails(row){

            this.activeNameChange('详情信息')
            localStorage.setItem('activeTab' , this.editableTabsValue)
            this.$router.push({path:'/details',query:{applyId:row.id}})

          },

    }



}
</script>

<style lang="less" scoped>
.btn{
  margin-bottom: 0;
  float: right;
  font-size: 1rem;
  width: 7.375rem;
  border-radius: 4px;
  overflow: hidden
}
.btn1{
  background: rgb(1, 137, 220);
  color: rgb(255, 253, 253);
}
.btn2{
  color: rgb(1, 137, 220);
  border: 1px solid rgb(1, 137, 220);
}

</style>
<style lang="less">
//修改elementUI组件样式,在组件上添加自定义的选择器
//????如何让标签均匀分布
.myTab .el-tabs__nav-wrap{
    display: flex; /* 使用Flexbox布局 */
    justify-content: space-between; /* 在主轴上均匀分布项目 */
    align-items: center; /* 在交叉轴上居中项目（可选） */

    //background-color: #181717;
  }
  .myTab .el-tabs__item{
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background: rgb(239, 245, 250);
    font-size: 1.25rem;
    font-weight: 400;
    color: rgb(3, 102, 180);
    border:none;
  }
  .myTab .el-tabs__header{
    margin: 0!important;
  }
  .myTab .el-tabs__content{
    //height: 11rem;
    box-sizing: border-box;
    border: 1px solid rgb(232, 235, 240);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    background: rgb(255, 255, 255);
    padding:.5rem;
    //background: #ff6700;
  }
  .myTab .el-tabs__item.is-active{
    background: rgb(27, 61, 109) !important;
    color: rgb(255, 255, 255) !important;
  }
  .myTab .el-radios{
      padding-bottom: 1rem;
    }
  .myTab .el-radio__label{
      font-size: 1rem ;
      color: rgb(27, 61, 109);
    }
  .myTab  .el-form-item__label{
    font-size: 1rem !important;
    color: rgb(27, 61, 109);
    }

.btnBox1{
  float: right;
  right: 1.5rem;
  bottom: 1rem;

}
</style>



// WEBPACK FOOTER //
// src/landmark-user/views/applicationQuery/index.vue